import BasicInformation from "./BasicInformation/BasicInformation";
import BiddingStrategy from "./BiddingStrategy/BiddingStrategy";
import BannerSetting from "./BannerSetting/BannerSetting";
import PrimaryButton from "../../../../components/common/PrimaryButton/PrimaryButton";
import AdPlacement from "./AdPlacement/AdPlacement";

const BannerAds = () => {
  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", padding: "20px 30px" }}>
      <h4 className="fw-semibold mb-3">Advertisement Campaign Creation</h4>

      <div className="px-2">
        <div className="fw-semibold fs-4 mb-3">Banner Ads</div>
        <BasicInformation />
        <BannerSetting />
        <AdPlacement />
        <BiddingStrategy />
      </div>

      <div className="d-flex justify-content-center mt-3">
        <span>
          <PrimaryButton name="Launch Campaign" />
        </span>
      </div>
    </div>
  );
};

export default BannerAds;